export default 'Note explicative de convocation AG : présenter clairement le projet, les aides et le reste à charge. Trame et accompagnement pour faire voter la rénovation.';
